exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3OS6E{background-size:cover;background-position:50%;background-repeat:no-repeat}._1NuZI{background-size:contain}._3OS6E.SmZYm{background-color:#a8a8a7}._3OS6E.SmZYm.g3gLI{background-image:linear-gradient(180deg,#eff8ff,#d5ebfa)}", ""]);

// exports
exports.locals = {
	"resized-image": "_3OS6E",
	"resizedImage": "_3OS6E",
	"background-contain": "_1NuZI",
	"backgroundContain": "_1NuZI",
	"with-fallback-color": "SmZYm",
	"withFallbackColor": "SmZYm",
	"dashboard": "g3gLI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/shared/components/resized-image/resized-image.styl
// module id = 613
// module chunks = app-settings/app-settings dashboard/email-marketing mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals shoutout/shoutout business-manager/shoutout-popup dashboard/settings dashboard/channel-edit dashboard/channels mobile/mobile dashboard/video-library dashboard/video-edit dashboard/new-upload dashboard/video-cards widget/strip widget/classic widget/compact dashboard/channel-info